export default __webpack_public_path__ + "static/media/BBTreeGB.9c8ac944.woff";